import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/jobFunctions/scheduleDrawingActions'
import { actions as jobNoteActions } from '../../../redux/modules/jobFunctions/jobNoteActions'
import Loader from '../../common/Loader'
import ScheduleDrawingDatesView from '../../../components/ScheduleDrawingDatesView'
import ScheduleMachinesMenu from '../../../components/ScheduleMachineMenu'
import Notes from '../../../components/notes/Notes'
import _ from 'lodash'

const propTypes = {}

class ScheduleDrawings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      machineIndex: this.props.scheduleApplicationId,
      arrayIndex: 0
    }

    this.props.getScheduleDrawingDates({
      jobId: this.props.jobId
    })

    this.props.getScheduleNote({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.scheduleDrawingActions.scheduleDrawingDates !==
        prevProps.scheduleDrawingActions.scheduleDrawingDates
    ) {
      this.setState({
        machineIndex: this.props.shortcutItemId,
        arrayIndex: _.findIndex(
          this.props.scheduleDrawingActions.scheduleDrawingDates.data,
          schedule => schedule.id === parseInt(this.props.shortcutItemId, 10)
        )
      })
      this.props.clearHighlight()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.scheduleDrawingActions.scheduleDrawingDates !==
      nextProps.scheduleDrawingActions.scheduleDrawingDates
    ) {
      this.setState({
        machineIndex:
          nextProps.scheduleDrawingActions.scheduleDrawingDates.data[
            nextProps.scheduleDrawingActions.scheduleDrawingDates.data.length - 1
          ].id,
        arrayIndex: nextProps.scheduleDrawingActions.scheduleDrawingDates.data.length - 1
      })
    }
  }

  handleEditDateClick = () => {
    this.setState({
      isEditing: true
    })
  }

  changeMachineIndex = (arrayIndex, index) => {
    this.setState({
      machineIndex: index,
      arrayIndex: arrayIndex
    })
  }

  handleDeleteSchedule = scheduleId => {
    this.props.deleteScheduleDrawing({
      jobId: this.props.jobId,
      scheduleId: scheduleId
    })
    this.setState({
      machineIndex: 1,
      arrayIndex: 0
    })
  }

  clearFields = () => {
    this.setState({ contentData: null, currentId: 0, isEditing: false })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createScheduleNote({
      content: params,
      userId: this.props.user.userId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editScheduleNote({
      content: params,
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteScheduleNote({
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  render() {
    const { scheduleDrawingDates } = this.props.scheduleDrawingActions

    if (!scheduleDrawingDates) {
      return <Loader />
    }

    return (
      <div>
        <div className="jobsBar">
          Schedule Drawings
          {!this.state.isEditing && (
            <div className="jobsBarAdd" onClick={() => this.handleEditDateClick()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT Dates</div>
            </div>
          )}
        </div>
        <ScheduleMachinesMenu
          data={scheduleDrawingDates.data}
          currentIndex={this.state.arrayIndex}
          changeMachineIndex={this.changeMachineIndex}
          addMachine={this.props.addScheduleDrawingDate}
          jobId={this.props.jobId}
          userId={this.props.user.userId}
        />
        <ScheduleDrawingDatesView
          data={scheduleDrawingDates.data[this.state.arrayIndex]}
          machineIndex={this.state.machineIndex}
          isEditing={this.state.isEditing}
          updateDrawingDates={this.props.updateDrawingDates}
          deleteSchedule={this.handleDeleteSchedule}
          updateNotes={this.props.updateNotes}
          jobId={this.props.jobId}
          clearFields={this.clearFields}
          clearHighlight={this.props.clearHighlight}
          scheduleDrawingType={this.props.scheduleDrawingType}
          userId={this.props.user.userId}
        />
        <div className="row p-5">
          <div className="col-12">
            <Notes
              // notes props
              currentNote={this.state.currentNote}
              currentNoteId={this.state.currentNoteId}
              notes={
                this.props.jobNoteActions.scheduleNotes &&
                this.props.jobNoteActions.scheduleNotes.data
              }
              handleToggleNoteEditArea={this.handleToggleNoteEditArea}
              noteAddEditContainer={this.state.noteAddEditContainer}
              createNote={this.createNote}
              handleRowNoteClick={this.handleRowNoteClick}
              updateNote={this.updateNote}
              userId={this.props.user.userId}
              deleteNote={this.deleteNote}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ scheduleDrawingActions, jobNoteActions }, ownProps) => ({
  scheduleDrawingActions,
  jobNoteActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, jobNoteActions), dispatch)
})

ScheduleDrawings.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleDrawings))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/ScheduleDrawings.js